/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/fullpaymentreport.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
  GET_FULL_PAYMENT_USERS,
  GET_FULL_PAYMENT_USERS_ADMIN,
  GET_PRESENTATIONS,
} from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment";
import { StorageModule } from "@vlinder-web/storage-module-react";
import jwt_decode from "jwt-decode";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetFullPaymentUsersMethods extends IPluginMethodMap {
  getFullPaymentUsers(args: any): Promise<any>;
}

export class GetFullPaymentUsersService implements IAgentPlugin {
  readonly methods: IGetFullPaymentUsersMethods;

  constructor() {
    this.methods = {
      getFullPaymentUsers: this.getFullPaymentUsers.bind(this),
    };
  }

  async getFullPaymentUsers(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filer_apply = args?.criteria ? args?.criteria : {},
      presentationOptions: any = [],
      defaultPresentation: any = "";
    console.log("filet apply====", filer_apply);

    filer_apply = this.convertCriteria(args?.criteria);
    let variables = {
      options: {
        limit: args?.size ?? 10,
        skip: args?.offset ?? 0,
        sort: {
          field: "createdAt",
          order: "desc",
        },
      },
      filter: {
        paymentStats: {
          eq: "Paid",
        },
        ...filer_apply,
      },
    };
    const _filter = {
      // status: {
      //   eq: "active",
      // },
      // year: {
      //   eq: "2024",
      // },
    };
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: 10,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        if (
          presentation &&
          presentation?.data?.getPresentations?.content[0]?.id
        ) {
          defaultPresentation =
            presentation?.data?.getPresentations?.content[0]?.id;
          presentationOptions =
            presentation?.data?.getPresentations?.content?.map((_item: any) => {
              return { value: _item?.id, label: _item?.name };
            });
          variables.filter.presentation = {
            eq: args?.criteria?.presentation ?? defaultPresentation,
          };
        }
        const storageSrv = StorageModule.getInstance();
        let _sessionToken = storageSrv.get(
          "userProfile",
          "session"
        )?.accessToken;
        let _localToken = storageSrv.get("userProfile", "local")?.accessToken;
        let _token = _localToken ?? _sessionToken;
        const tokenRole = jwt_decode(_token);
        const res = await client.query({
          query:
            tokenRole?.currentRole?.name === "production"
              ? GET_FULL_PAYMENT_USERS
              : GET_FULL_PAYMENT_USERS_ADMIN,
          variables: variables,
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(
            res?.data?.getUserAdvancedSearch?.content
          );

          let _totalPages = res?.data?.getUserAdvancedSearch?.count
            ? Math.ceil(parseInt(res?.data?.getUserAdvancedSearch?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getUserAdvancedSearch?.skip /
              res?.data?.getUserAdvancedSearch?.limit +
            1;
          console.log("_rowData==>", _rowData);
          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getUserAdvancedSearch?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getUserAdvancedSearch?.count,
            totalPages: _totalPages,
            searchPresentationFilter: presentationOptions,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      if (key != "presentation") result[key] = { contains: criteria[key] };
    }
    return result;
  }

  private formatAmount(amount: any): string {
    const num = Number(amount);
    if (isNaN(num)) return "0.00";
    return num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  private formatUSD(amount: any): string {
    const num = Number(amount);
    if (amount === null || amount === undefined || isNaN(num) || num <= 0) {
      return "-";
    }
    return `$${this.formatAmount(amount)}`;
  }

  private formatTTD(amount: any): string {
    const num = Number(amount);
    if (amount === null || amount === undefined || isNaN(num) || num <= 0) {
      return "-";
    }
    return `TTD ${this.formatAmount(amount)}`;
  }

  private getAggregatedPayments(payOrdersData: any) {
    const orders = Array.isArray(payOrdersData)
      ? payOrdersData
      : payOrdersData
      ? [payOrdersData]
      : [];

    let totalUSD = 0;
    let hasUSD = false;
    let totalTTD = 0;
    let hasTTD = false;

    orders.forEach((order: any) => {
      if (order?.paidUSD !== null && order?.paidUSD !== undefined) {
        const numUSD = Number(order.paidUSD);
        if (!isNaN(numUSD) && numUSD > 0) {
          totalUSD += numUSD;
          hasUSD = true;
        }
      }

      if (order?.paidTTD !== null && order?.paidTTD !== undefined) {
        const numTTD = Number(order.paidTTD);
        if (!isNaN(numTTD) && numTTD > 0) {
          totalTTD += numTTD;
          hasTTD = true;
        }
      }
    });

    const paidUSD = hasUSD && totalUSD > 0 ? this.formatUSD(totalUSD) : "-";
    const paidTTD = hasTTD && totalTTD > 0 ? this.formatTTD(totalTTD) : "-";

    return {
      paidUSD,
      paidTTD,
    };
  }

  private formatTable(users: any[]): any {
    let _rowData: any = [];
    users &&
      users.forEach((data?: any) => {
        if (data?.paymentStats === "Paid") {
          const { paidUSD, paidTTD } = this.getAggregatedPayments(
            data?.PayOrders
          );

          _rowData.push({
            id: data?._id ?? "-",
            name: data?.User?.fullName ?? "Null Null",
            email: data?.User?.email ?? "-",
            userId: data?.User?._id,
            Committee:
              data?.ReferalUsers && data?.ReferalUsers.length > 0
                ? data?.ReferalUsers[0]?.fullName
                : "-",
            dateCreated: data?.createdAt
              ? moment(data?.createdAt).format("L")
              : "",
            cosId: data?.costumeID ?? "-",
            masqId: data?.User?.vuid ?? "-",
            costumeCost: data?.totalAmount,
            TypeName: data?.CostumeType?.name,
            SectionName: data?.Section?.name,
            totalpaidTTd: paidTTD,
            paidUSD,
            paidTTD,
          });
        }
      });
    return _rowData;
  }
}
